module.exports = __webpack_public_path__ + "img/sport-1-@3x.4106c0ef.png";